/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useEffect } from 'react';
import { format, parse } from 'date-fns';
import _ from 'lodash';

export const CreateTicketsParticipations = ({ startDateTimes, postUrl }: any) => {
  const [startTime, setStartTime] = useState('');
  const [availableStartDateTimes, setAvailableStartDateTimes] = useState([]);
  const [availableStartDates, setAvailableStartDates] = useState([]);
  const [selectedStartDateOption, setSelectedStartDateOption] = useState(null);
  const [availableStartTimes, setAvailableStartTimes] = useState([]);
  const [selectedStartTimeOption, setSelectedStartTimeOption] = useState(null);

  const csrfToken = (document.querySelector('[name=csrf-token]') as any)?.content;

  /* Utils */
  const timeToyyyyMMdd = (time: any) => {
    return format(parse(time, 'yyyy-MM-dd HH:mm:ss', new Date()), 'yyyy-MM-dd');
  };

  const timeToHHmm = (time: any) => {
    return format(parse(time, 'yyyy-MM-dd HH:mm:ss', new Date()), 'HH:mm');
  };

  const generateStartDates = () => {
    return _.uniq(_.map(availableStartDateTimes, (time: any) => timeToyyyyMMdd(time)));
  };

  const generateStartTimes = () => {
    const availableStartTimesArray = _.filter(availableStartDateTimes, (time: any) => {
      const time_yyyy_MM_dd = timeToyyyyMMdd(time);
      return time_yyyy_MM_dd == selectedStartDateOption.value;
    });
    return _.uniq(_.map(availableStartTimesArray, (time: any) => timeToHHmm(time)));
  };

  const generateStartTime = () => {
    return (
      _.find(availableStartDateTimes, (time: any) => {
        return (
          timeToyyyyMMdd(time) == selectedStartDateOption.value &&
          timeToHHmm(time) == selectedStartTimeOption.value
        );
      }) || ''
    );
  };

  /* Generate contents from state */
  const isFormValid = () => {
    return startTime;
  };

  /* State hooks */
  useEffect(() => {
    if (startDateTimes) {
      setAvailableStartDateTimes(
        startDateTimes['start_times'].map((time: any) =>
          format(parse(time, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", new Date()), 'yyyy-MM-dd HH:mm:ss'),
        ),
      );
    }
  }, [startDateTimes]);

  useEffect(() => {
    setAvailableStartDates(generateStartDates());
  }, [availableStartDateTimes]);

  useEffect(() => {
    setAvailableStartTimes(generateStartTimes());
  }, [selectedStartDateOption]);

  useEffect(() => {
    setStartTime(generateStartTime());
  }, [selectedStartTimeOption]);

  /* JSX itself */
  return (
    <div>
      <Form action={postUrl} method="post">
        <input type="hidden" name="start_time" value={startTime} />
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <Form.Group controlId="input">
          <div className={'ml-2'}>
            <Form.Label className={'label font-weight-normal'}>日にちを選んでください</Form.Label>
            <Select
              name="date"
              value={selectedStartDateOption}
              options={availableStartDates.map((v) => {
                return { value: v, label: v };
              })}
              onChange={(selectedOption: any) => {
                setSelectedStartDateOption(selectedOption);
              }}
            />
          </div>
        </Form.Group>
        <Form.Group controlId="input">
          <div className={'ml-2'}>
            <Form.Label className={'label font-weight-normal'}>時間を選んでください</Form.Label>
            <Select
              name="time"
              value={selectedStartTimeOption}
              options={availableStartTimes.map((v) => {
                return { value: v, label: v };
              })}
              onChange={(selectedOption: any) => setSelectedStartTimeOption(selectedOption)}
            />
          </div>
        </Form.Group>
        <div className={'ml-3 my-3 text-danger'}>
          チケットの有効期限は付与日より60日間です。有効期限内でのレッスンの受講に使用いただけます。
          <br />
          予約は受講日時の前日まで可能です。当日の予約はできませんのでご注意ください。
        </div>
        <Form.Group controlId="input">
          <div>
            {/* @ts-ignore Occurs during typescript migration. The variant does not contain brand-purple, but we have not yet confirmed which color is appropriate. */}
            <Button type="submit" variant="brand-purple" disabled={!isFormValid()}>
              予約する
            </Button>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
};

CreateTicketsParticipations.propTypes = {
  startDateTimes: PropTypes.object,
  postUrl: PropTypes.string,
};
